<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="交易状态" name="transactionStatus">
                <DictSelect
                            v-model:value="searchForm.transactionStatus"
                            :dict-name="financeDict.ADUIT_STATUS"
                            placeholder="请选择交易状态"
                        />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">

            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <!-- <template #index="{index}">{{ index + 1 }}</template> -->
            <template #propertyNames="{record}">
                <a @click="onDetail(record)">{{record.propertyNames}}</a>
            </template>
            <template #propertyType="{text}">
                <dict-render :dict-obj="dictObjs['property_type']" :text="text"></dict-render>
            </template>
            <template #auditStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['aduit_status']" :text="text"
                                 :style="dictObjs['aduit_status']?.cssClass"></dict-render>
                </a-tag>
            </template>
            <template #transactionStatus="{text}">
                <a-tag>
                    <dict-render :dict-obj="dictObjs['transaction_status']" :text="text"
                                 :style="dictObjs['transaction_status']?.cssClass"></dict-render>
                </a-tag>
            </template>
            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->

                    <a-dropdown>
                        <template #overlay>
                            <a-menu>
                                <a-menu-item key="1">
                                    <a @click="onEdit(record)">编辑</a>
                                </a-menu-item>
                                <a-menu-item key="2">
                                    <a @click="onSellerCancel(record)">取消交易</a>
                                </a-menu-item>
                                <a-menu-item key="3">
                                    <a @click="onJoint(record)">意向列表</a>
                                </a-menu-item>
                            </a-menu>
                        </template>
                        <a class="ant-dropdown-link" @click.prevent>更多
                            <DownOutlined/>
                        </a>
                    </a-dropdown>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <PublishTransactionsModal ref="publishModal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="detailmodal" :form-primary-key-field="listKeyField" @finish="onFormEdited" @onCloseModel="onCloseModel"/>
    <IntentionListModal ref="intentionListModal" :transactionId="transactionId" @onCloseModel="onCloseModel"/>

</template>

<script>
    import AddOrEditModal from "./components/AddOrEditModal";
    import PublishTransactionsModal from "./components/PublishTransactionsModal"
    import {dictMixin, tableListMixin} from "@/mixins";
    import {tradeApi} from "@/api/knowledge";
    import DictRender from "@/components/other/DictRender";
    import Detail from "./components/DetailModal"
    import IntentionListModal from "./components/IntentionListModal"
    import DictSelect from "@/components/other/DictSelect";
    import {financeDict} from "@/config/variableConfig";
    const columns = [
        // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        // {title: "单号", dataIndex: "id", key: "id"},
        {title: "名称", dataIndex: "propertyNames", key: "propertyNames", slots: {customRender: "propertyNames"}},
        {title: "产权类型", dataIndex: "propertyType", key: "propertyType", slots: {customRender: "propertyType"}},
        // {title: "交易价格", dataIndex: "price", key: "price"},
        {title: "交易状态", dataIndex: "transactionStatus", key: "transactionStatus",slots: {customRender: "transactionStatus"}},
        // {title: "交易审核状态", dataIndex: "auditStatus", key: "auditStatus",slots: {customRender: "auditStatus"}},
        {title: "操作", dataIndex: "action", key: "action", slots: {customRender: "action"}},
    ];
    export default {
        name: "index",
        mixins: [tableListMixin, dictMixin],
        components: {
            DictRender,DictSelect, AddOrEditModal, Detail,PublishTransactionsModal,IntentionListModal
        },
        data() {
            return {
                financeDict,
                dictNames: 'aduit_status,property_type,transaction_status',
                columns,
                queryParamFixed: {},
                listUrl: tradeApi.pageList,
                listKeyField: "id",
                deleteUrl: tradeApi.remove,
                transactionId: null,
            }
        },
        methods: {
            onAdd() {
                this.onShowModal('modal');
            },
            onEdit(record) {
                this.getAction({
                    url: tradeApi.detail,
                    params: {id: record.id}
                }).then(res => {
                    this.onShowModal('modal', res);
                })
            },
            onSellerCancel(record) {
                this.postAction({
                    url: tradeApi.sellerCancel,
                    params: {id: record.id}
                }).then(res => {
                    console.log("res", res)
                })
            },
            onDetail(record) {
                this.getAction({
                    url: tradeApi.detail,
                    params: {
                        id: record.id,
                    }
                }).then(res => {
                    console.log(res, 'res')
                    this.onShowModal("detailmodal", res)
                })
            },
            onJoint(record) {
                this.transactionId = record.id
                this.onShowModal('intentionListModal');
            },
            onCloseModel() {
                this.loadData(1)
            }
        }
    }
</script>

<style scoped>

</style>
